import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CardStatus } from 'src/graphql/generated/graphql.generated';

@Component({
  selector: 'tcs-load-card',
  templateUrl: './load-card.component.html',
  styleUrls: ['./load-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadCardComponent implements OnInit {
  @Input() public context: {
    type: CardStatus;
    isCondensed: boolean;
  } = { type: CardStatus.AwaitingAssignment, isCondensed: false };

  constructor() {}

  public ngOnInit() {}
}
